import React from "react";
import classNames from "classnames";
import { PodcastCard } from "./PodcastCard";
import { COLUMN_LABELS, PODCAST_COLUMNS } from "./constants";
import type { PodcastEpisodeColumnProps } from "./types";

export const PodcastEpisodeColumn: React.FC<PodcastEpisodeColumnProps> = ({
  columnType,
  episodes,
  className,
}) => {
  const isValidColumnType =
    columnType === PODCAST_COLUMNS.LATEST || columnType === PODCAST_COLUMNS.TOP;

  if (!isValidColumnType) {
    // eslint-disable-next-line no-console
    console.warn(`Invalid podcast column type: ${columnType}`);
    return null;
  }

  const columnLabel =
    COLUMN_LABELS[
      columnType as typeof PODCAST_COLUMNS.LATEST | typeof PODCAST_COLUMNS.TOP
    ];

  return (
    <div
      className={classNames("flex flex-col gap-4", className)}
      data-testid={`podcast-column-${columnType}`}
    >
      <div className="flex items-center justify-between">
        <h2 className="text-brand-neutral font-emphasis-18">{columnLabel}</h2>
      </div>

      <div className="flex flex-col gap-4">
        {episodes.map((episode) => (
          <PodcastCard key={episode.id} episode={episode} />
        ))}
      </div>
    </div>
  );
};

PodcastEpisodeColumn.displayName = "PodcastEpisodeColumn";

export default PodcastEpisodeColumn;
